import React from "react";
import { ArrowLeft01Icon, ArrowRight01Icon } from 'hugeicons-react';
import '../../Styles/Layout/Resources/VersionControls.css';
import { Resource } from "../../types/resource";

interface VersionControlsProps {
  currentIndex: number;
  versions: Resource[];
  setCurrentIndex: (index: number) => void;
}

const VersionControls: React.FC<VersionControlsProps> = ({
  currentIndex,
  versions,
  setCurrentIndex,
}) => {

  const toggleVersionControl = (direction: 'previous' | 'next') => {
    if (versions.length <= 1) return;

    let newIndex = currentIndex;
    if (direction === 'previous' && currentIndex > 0) {
      newIndex = currentIndex - 1;
    } else if (direction === 'next' && currentIndex < versions.length - 1) {
      newIndex = currentIndex + 1;
    }
    setCurrentIndex(newIndex);
  };

  if (versions.length <= 1) return null;
  return (
    <div className="version-controls">
      <button
        className="version-nav-btn prev"
        onClick={() => toggleVersionControl('previous')}
        disabled={currentIndex === 0}
        aria-label="Previous version"
      >
        <ArrowLeft01Icon />
      </button>
      <div className="version-display">
        <span className="version-current">{currentIndex + 1}</span>
      </div>
      <button
        className="version-nav-btn next"
        onClick={() => toggleVersionControl('next')}
        disabled={currentIndex === versions.length - 1}
        aria-label="Next version"
      >
        <ArrowRight01Icon />
      </button>
    </div>
  );
};

export default VersionControls;
